// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1P5XP","productName":"Table_productName__2rJYa"};